
export class ParkForReservedSubscriber {
  public id: number;
  public parkDescription: string;
 }
